<template>
  <div class="payment">
    <!-- <div class="costs">
      <p>需支付金额</p>
      <div class="amount ">¥ 330.00元</div>
      <div class="paydes">支付说明：此费用为平台使用费</div>
    </div>
    <form class="form-horizontal">
      <div class="form-group row">
        <label class="radio-inline">
          <input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1">
          <img src="../../../assets/images/zfb.png"/>支付宝支付
        </label>
        <label class="radio-inline">
          <input type="radio" name="inlineRadioOptions" id="inlineRadio2" value="option2"> <img src="../../../assets/images/wx.png"/>微信支付
        </label>
        <label class="radio-inline">
          <input type="radio" name="inlineRadioOptions" id="inlineRadio3" value="option3"> <img src="../../../assets/images/yl.png"/>银行卡支付
        </label>
      </div>
      <button type="submit" class="btn btn-default">提交</button>
    </form> -->
    <a-spin :spinning="paySpinning" v-if="costType === 0">
      <div class="content">
        <div class="pays" v-if="homeObj.is_show_feedetail_info != '0' && params">
          <h1 class="text-center paytitle">{{ params.subject || '' }}</h1>
          <div class="tablebg">
            <table class="table table-hover">
              <tr>
                <td class="table-td1">姓名</td>
                <td class="table-td">{{ params.body || '' }}</td>
              </tr>
              <tr>
                <td class="table-td1">学校</td>
                <td class="table-td">{{ userInfo.eduName || '' }}</td>
              </tr>
              <tr>
                <td class="table-td1">教学点</td>
                <td class="table-td">{{ params.studyCenter || '' }}</td>
              </tr>
              <tr>
                <td class="table-td1">层次</td>
                <td class="table-td">{{ userInfo.learnLevel || '' }}</td>
              </tr>
              <tr>
                <td class="table-td1">专业</td>
                <td class="table-td">{{ userInfo.proName || '' }}</td>
              </tr>
              <tr>
                <td class="table-td1">金额</td>
                <td class="table-td">
                  <span class="amount">{{ (params.totalFee || 0) * 0.01 }}</span
                  >元
                </td>
              </tr>
              <tr v-if="remark">
                <td class="table-td1">备注</td>
                <td class="table-td">{{ remark }}</td>
              </tr>
            </table>
          </div>

          <div class="text-center">
            <button class="btn btn-default" type="submit" @click="gotoPay">
              <i class="iconfont icon-youjiantou margin-r-10"></i>去缴费
            </button>
          </div>
        </div>
        <div v-if="desc" style="display: flex; justify-content: center">
          <p style="margin-top: 20px" v-html="desc"></p>
        </div>
      </div>
    </a-spin>

    <a-spin :spinning="paySpinning" v-else-if="costType === 1">
      <div style="margin-top: 20px">
        <h3 style="text-align: center; font-weight: bold; font-size: 16px">
          已缴费明细
        </h3>
        <a-table
          style="padding: 10px"
          :columns="alreadyColumns"
          :data-source="feeSubList"
        >
        </a-table>
      </div>

      <div>
        <h3 style="text-align: center; font-weight: bold; font-size: 16px">
          未缴费明细
        </h3>
        <a-table
          style="padding: 10px"
          :columns="notColumns"
          :data-source="subList"
        />
      </div>

      <div style="margin-left: 80%; font-size: 20px" class="amount">
        费用：{{ feeDto.fee }} 元
      </div>

      <div style="margin: 20px 77% 0">
        <button class="btn btn-default" type="submit" @click="gotoPay">
          <i class="iconfont icon-youjiantou margin-r-10"></i>去缴费
        </button>
      </div>
    </a-spin>
  <div class="content"  v-else-if="costType === 2">
      <div>
        缴费状态为 已缴费 ，您有 {{ onlineOrders || 0 }}笔 线上缴费。
      </div>

    
    <div style="margin: 20px 77% 0">
        <button class="btn btn-default" type="button" @click="gotoInvoice">
          <i class="iconfont icon-youjiantou margin-r-10"></i>申请发票
        </button>
      </div>
      
  </div>
    <div v-else class="placeholder">您的缴费状态为：暂无需缴费。</div>


    <form :action="url" method="post" target="_blank" v-show="false">
      <input type="text" name="appFlag" v-model="params.appFlag" />
      <input type="text" name="appOrderNo" v-model="params.appOrderNo" />
      <input type="text" name="appid" v-model="params.appid" />
      <input type="text" name="body" v-model="params.body" />
      <input
        type="text"
        name="contentThrough"
        v-model="params.contentThrough"
      />
      <input type="text" name="nonceStr" v-model="params.nonceStr" />
      <input type="text" name="sign" v-model="params.sign" />
      <input type="text" name="subject" v-model="params.subject" />
      <input type="text" name="t" v-model="params.t" />
      <input type="text" name="totalFee" v-model="params.totalFee" />
      <input type="text" name="idno" v-model="params.idno" />
      <input type="text" name="name" v-model="params.name" />
      <input type="text" name="phone" v-model="params.phone" />
      <input type="text" name="studyCenter" v-model="params.studyCenter" />
      <input type="text" name="grade" v-model="params.grade" />
      <input type="text" name="collegeName" v-model="params.collegeName" />
      <input type="text" name="collegeCode" v-model="params.collegeCode" />
      <input type="submit" ref="submit" value="提交" />
    </form>
    <!-- 手动触发的缴费通知弹窗 -->
    <PayNotifyModal
      :visible="payNotifyVisible"
      :content="payNotifyContent"
      @goPay="onPayNotifyGoPay"
      @goRegister="onPayNotifyGoRegister"
      @close="onPayNotifyClose"
    />
    <!-- 登记弹窗 -->
    <RegisterModal :visible="registerModalVisible" @close="registerModalVisible = false" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import PayNotifyModal from '@/pages/home/components/PayNotifyModal.vue';
import RegisterModal from '@/pages/home/components/RegisterModal.vue';

export default {
  name: "Payment",
  components: {
    PayNotifyModal,
    RegisterModal,
  },
  data: function () {
    return {
      url: null,
      params: {},
      paySpinning: true,
      onlineOrders: 0, // 线上缴费订单数
      payNotifyVisible: false,
      payNotifyContent: '',
      registerModalVisible: false,
      notColumns: [
        {
          align: "center",
          title: "序号",
          customRender: (text, record, index) => `${index + 1}`,
        },
        {
          align: "center",
          title: "学年",
          dataIndex: "layoutYear",
        },
        {
          align: "center",
          title: "学期",
          dataIndex: "layoutTermName",
        },
        {
          align: "center",
          title: "课程代码",
          dataIndex: "viewCode",
        },
        {
          align: "center",
          title: "课程名称",
          dataIndex: "viewName",
          // customCell: () => {
          //     return {
          //         style: {
          //         'text-align': 'left'
          //         },
          //     };
          // },
        },
      ],
      alreadyColumns: [
        {
          align: "center",
          title: "序号",
          customRender: (text, record, index) => `${index + 1}`,
        },
        {
          align: "center",
          title: "学年",
          dataIndex: "layoutYear",
        },
        {
          align: "center",
          title: "学期",
          dataIndex: "layoutTermName",
        },
        {
          align: "center",
          title: "课程代码",
          dataIndex: "viewCode",
        },
        {
          align: "center",
          title: "课程名称",
          dataIndex: "viewName",
          // customCell: () => {
          //     return {
          //         style: {
          //         'text-align': 'left'
          //         },
          //     };
          // },
        },
      ],
      subList: [],
      feeSubList: [],
      feeDto: {},
      costType: 0,
      desc: "",
      remark: "",

    };
  },
  computed: {
    ...mapState(["city", "userInfo", "homeObj"]),
  },
  methods: {
    gotoPay() {
      // 手动触发缴费通知检查（跳过登记状态验证）
      this.axios.get('/biz/user/pay/notifyCheckManual').then(res => {
        // 必办项校验：有必办项时提示并跳转待办列表
        if (res.code === 200 && res.result && res.result.mustDeal) {
          this.handleMustDeal(res.result.mustDeal);
          return;
        }
        if (res.code === 200 && res.result && res.result.show) {
          // 有缴费通知，先弹出通知弹窗
          this.payNotifyContent = res.result.content;
          this.payNotifyVisible = true;
        } else {
          // 无通知，直接执行原缴费逻辑
          this.doGotoPay();
        }
      }).catch(() => {
        this.doGotoPay();
      });
    },
    /**
     * 必办项处理：与 /mustDeal/check 弹出提示样式一致，提示后跳转待办列表
     */
    handleMustDeal(mustDeal) {
      if (mustDeal === 1) {
        this.$message.error('您还有未处理的必办事项！');
      } else if (mustDeal === -1) {
        this.$message.error('请耐心等待必办审核完成！');
      }
      this.$router.push('/todos/list');
    },
    // 原缴费逻辑
    doGotoPay() {
      this.url = null;
      this.axios.get(`/biz/user/toPay?type=1`).then((res) => {
        if (res.code === 200) {
          this.params = res.result.param;
          this.url = res.result.url;
          if (this.url) {
            setTimeout(() => {
              this.$refs.submit.click();
            }, 200);
          }
        }
      });
    },
    // 缴费通知弹窗按钮事件
    onPayNotifyGoPay() {
      this.payNotifyVisible = false;
      this.doGotoPay();
    },
    onPayNotifyGoRegister() {
      this.payNotifyVisible = false;
      // 去登记：打开登记缴费信息弹窗
      this.registerModalVisible = true;
    },
    onPayNotifyClose() {
      this.payNotifyVisible = false;
      // 关闭弹窗，停留在原页面，不执行缴费
    },
    gotoInvoice() {
      this.$router.push('/personalcenters/invoice/list')
    },

  },

  mounted() {
    // 检查是否从缴费通知弹窗跳转过来
    if (this.$route.query.action) {
      console.log('缴费通知跳转参数:', this.$route.query.action);
    }
    this.axios
      .get(`/biz/user/pay/get?type=1`)
      .then((res) => {
        this.paySpinning = false;
        if (res.result.onlineOrders!=undefined) {
          if (res.result.onlineOrders>0) {//显示开票按钮
            this.costType=2;
            this.onlineOrders = res.result.onlineOrders;
          } else {
            this.costType=3;// onlineOrders==0，显示"暂无需缴费"
          }
        }else{
          this.params = res.result.param;
          this.feeSubList = res.result.feeSubList;
          this.subList = res.result.subList;
          this.feeDto = res.result.feeDto;
          this.costType = res.result.costType;
          this.desc = res.result.desc;
          this.remark = res.result.remark;
        }
      })
      .catch((err) => {
        this.paySpinning = false;
      });


  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/mixins.styl';

.payment {
  background: $bgcontent;
  padding: 28px;
  min-height: 640px;

  .paydetail {
    height: 68px;
    line-height: 68px;
    background: #fff;
    border: 1px solid #f2f2f2;
    margin-left: 20px;
  }

  .radio-inline {
    margin-right: 50px;
    margin-left: 15px;
  }

  .costs {
    margin-top: 30px;

    p {
      margin-bottom: 20px;
    }

    .amount {
      font-size: 36px;
      color: #fd9418;
      margin-bottom: 20px;
    }

    .paydes {
      color: #999;
    }
  }

  .form-horizontal {
    margin-top: 30px;
  }

  .btn {
    width: 154px;
    height: 42px;
    line-height: 42px;
    background: $bgColor;
    color: #fff;
    padding: 0;
  }
}

.pays {
  width: 400px;
  margin: 0 auto;
}

.content {
  background-color: #fff;
  padding: 28px;
}

.tablebg {
  border: 1px solid #efefef;
  padding: 30px;
  margin-top: 20px;
  margin-bottom: 20px;
}

.table th, .table td {
  border-top: none;
}

.paytitle {
  font-size: 16px;
  font-weight: bold;
}

.table-td1 {
  color: #999;
  text-align-last: justify;
  width: 70px;
}

.margin-r-10 {
  margin-right: 5px;
}

.amount {
  color: $bgColor;
  font-weight: bold;
}

.placeholder {
  width: 100%;
  height: 200px;
}


</style>



// WEBPACK FOOTER //
// src/pages/PersonalCenters/components/Payment.vue